import { ReactNode } from 'react';

interface JapanLayoutProps {
  children: ReactNode;
  Header: ReactNode;
  Footer: ReactNode;
}

export default function JapanLayout({ children, Header, Footer }: JapanLayoutProps) {
  return (
    <div className="app">
      <div className="header-area">
        <div className="top-banner marquee">
          <span>★★ 新しいメンバーが仲間入りしました！★★ ご支援お待ちしています ★★ 更新日: 2026.01.13 ★★</span>
        </div>
        {Header}
        <div className="marquee-container">
          <div className="marquee">
            ★ 保護動物たちのために、ご支援をお願いいたします ★  новые животные ждут вашей помощи ★ Every donation helps save lives ★
          </div>
        </div>
      </div>
      <main>
        <div className="main-layout">
          <aside className="sidebar-left">
            <div className="sidebar-box">
              <h3>カテゴリー</h3>
              <ul>
                <li><a href="/">ホーム</a></li>
                <li><a href="/stories">活動日記</a> <span className="new-badge">NEW</span></li>
                <li><a href="/about">私たちについて</a></li>
                <li><a href="#">里去志募集</a></li>
                <li><a href="#">ボランティア</a></li>
                <li><a href="#">寄付について</a></li>
              </ul>
            </div>
            <div className="sidebar-box">
              <h3>ランキング</h3>
              <ul>
                <li>🥇  Buddy</li>
                <li>🥈  Luna</li>
                <li>🥉  Max</li>
                <li>4位 Momo</li>
                <li>5位 Coco</li>
              </ul>
            </div>
            <div className="sidebar-box">
              <h3>リンク</h3>
              <ul>
                <li><a href="#">相互リンク</a></li>
                <li><a href="#">BBS</a></li>
                <li><a href="#">ゲストブック</a></li>
                <li><a href="#">メールフォーム</a></li>
              </ul>
            </div>
          </aside>
          <div className="content-area">
            {children}
          </div>
          <aside className="sidebar-right">
            <div className="sidebar-box">
              <h3>更新情報</h3>
              <ul>
                <li>01/13 <a href="#">新年企画開始</a></li>
                <li>01/10 <a href="#">新メンバー紹介</a></li>
                <li>01/05 <a href="#">医療費ご報告</a></li>
                <li>12/28 <a href="#">年末のご挨拶</a></li>
                <li>12/20 <a href="#">支援物資到着</a></li>
              </ul>
            </div>
            <div className="sidebar-box">
              <h3>天気予報</h3>
              <ul>
                <li style={{textAlign: 'center', padding: '10px 0'}}>
                  <span style={{fontSize: '24px'}}>☀️</span>
                  <br />東京 12℃
                  <br /><small>晴れのち 快晴</small>
                </li>
              </ul>
            </div>
            <div className="sidebar-box">
              <h3>カウンター</h3>
              <ul style={{textAlign: 'center'}}>
                <li>
                  <span className="counter">012345</span>
                  <div className="updated">昨日: 234人</div>
                </li>
              </ul>
            </div>
          </aside>
        </div>
        <hr className="divider" />
      </main>
      {Footer}
    </div>
  );
}
